import * as React from 'react';

import OtherLinks from '../../components/OtherLinks';
import Footer from '../../components/Footer';

interface ErrorProps {
    message: string;
}

export default class Error extends React.Component<ErrorProps, undefined> {

    render() {
        return <div className="Error">
                <p>Error: An error occurred while loading the Protected Trust addin: {this.props.message}</p>
                <Footer />
            </div>;
    }
}
    



// WEBPACK FOOTER //
// ./src/D:/a/1/s/src/tasks/Error/Error.tsx